@if(searchResult$ | async; as searchResult) {
  <udex-filter-menu mode="MultiSelect" [searchPlaceholder]="'search.enterKeyword' | cxTranslate: {field: facet.name}" [filterName]="facet.name" width="20rem" height="13.75rem"
    data-cy="facet-filter" placement-type="Bottom" (selectionChange)="onFilterSelect($event)" (resetClick)="resetClick($event)">
    @for (facetValue of facet.values; track facetValue.count) {
      @if (facetValue?.name?.length) {
        <udex-filter-menu-item [selected]="facetValue.selected"
          [disabled]="!facetSearchService.isActiveFacetValue(facetValue, facet.name, searchResult.facets)" [label]="facetValue.name"
          [supportingText]="!!facetValue?.['description'] ? facetValue?.['description'] : null" data-cy="facet-list" tabindex="1">
        </udex-filter-menu-item>
      }
    }
  </udex-filter-menu>
}
